export default {
  DASHBOARD: "/dashboard",
  CREATE_DOCUMENT: "/documents/document/create",
  USER: "/users",
  COMPANY: "/companies",
  JOB: "/jobs",
  ROLE: "/roles",
  DOCUMENT_CONSTRUCTOR: "/documents/document-constructor",
  NOMENCLATURE: "/documents/nomenclature",
  PROCESS_TEMPLATE: "/documents/process-template",
  DOCUMENT_TEMPLATE: "/documents/document-template",
  PROFILE: "/profile",
  ENTITY_APPROVAL: "/entity-approval",
  MY_DOC: "/documents/document",
  MY_DOC_PROCESS: "/documents/process-user",
  MY_DOC_REWORK: "/documents/document",
  MY_DOC_TRACKING: "/documents/document",
  MY_DOC_NEW: "/documents/document",
  MY_DOC_FAVORITE: "/documents/document",
  DOCUMENT_STRUCTURE: "/document-structure",
  EDMS_LOGS: "/logs",
  HELPDESK: "/helpdesk",
  REPORTS: "/reports",
  HR: "/hr",
} as Record<string, string>;
